import { ReactElement } from 'react';

import { ButtonHtmlProps, ObjectValues, LinkHtmlProps } from '../types';

export const sizes = {
  small: 'small',
  basic: 'basic',
  large: 'large',
} as const;

export const variants = {
  complete: 'complete',
  cta: 'cta',
  ctaSecondary: 'cta-secondary',
  ctaSecondaryWhite: 'cta-secondary-white',
  primary: 'primary',
  primaryDestructive: 'primary-destructive',
  primaryWhite: 'primary-white',
  secondary: 'secondary',
  secondaryWhite: 'secondary-white',
  secondaryDestructive: 'secondary-destructive',
  tertiary: 'tertiary',
  tertiaryDestructive: 'tertiary-destructive',
  fixedTertiary: 'fixed-tertiary',
  waitlist: 'waitlist',
  waitlistSecondary: 'waitlist-secondary',
} as const;

export const themes = {
  spinner: 'spinner',
  normal: 'normal',
} as const;

type TextProp = {
  text: string;
  ariaLabel?: never;
};

type AriaLabelProp = {
  ariaLabel: string;
  text?: never;
};

type BasicProps = {
  className?: string;
  elementName?: string;
  leadingIcon?: ReactElement;
  trailingIcon?: ReactElement;
  hasStackedIcon?: boolean;
  size?: ObjectValues<typeof sizes>;
  testId?: string;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
  wide?: boolean;
};

type CommonProps = (BasicProps & TextProp) | (BasicProps & AriaLabelProp);

export type VisuallyButtonButton = CommonProps & ButtonHtmlProps;

export type VisuallyButtonLink = CommonProps & LinkHtmlProps;

// NOTE: If the element isn't `a` or `button` we don't restrict the type of the rest props
type VisuallyButtonOther = CommonProps & {
  [key: string]: unknown;
};

export type VisuallyButton =
  | ({ elementName: 'button' } & VisuallyButtonButton)
  | ({ elementName: 'a' } & VisuallyButtonLink)
  | ({ elementName: string } & VisuallyButtonOther);
